export const serverDateToClientDate = ({ year, month, day, }) => {
    return new Date(year, month - 1, day, 0, 0, 0, 0);
};
//# sourceMappingURL=date.js.map